/**
 * Bearer-token persistence for the admin SPA.
 *
 * The token is stored in `localStorage` so a refresh keeps the session
 * alive until the JWT expires. Pages Functions cookie-flow was the
 * original design (Requirement 20.2) but proved unreliable on the
 * deployed Pages project, so we fall back to direct browser → Worker
 * calls with the token in localStorage. The trade-off is that the JWT
 * is now reachable from JavaScript; we mitigate by:
 *   - using a short 24h expiry (Worker enforces),
 *   - clearing the token on sign-out and on 401,
 *   - never logging it.
 */

const KEY = 'skey_admin_token';

export function getStoredToken(): string | null {
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setStoredToken(token: string): void {
  try {
    window.localStorage.setItem(KEY, token);
  } catch {
    // Storage may be unavailable (private mode, quota). Sign-in will
    // fail gracefully on the next request because no token round-trips.
  }
}

export function clearStoredToken(): void {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    // Best effort.
  }
}
